import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getPenStudyAnalyses = asyncThunkWrapper({ 
  model: 'penStudyAnalyses', 
  action: 'getPenStudyAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at']
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/pen_study_flow/pen_study_analyses', { params });

    return response.data;
  } 
});
export const getPenStudyAnalysis = asyncThunkWrapper({ 
  model: 'penStudyAnalyses', 
  action: 'getPenStudyAnalysis', 
  func: async ({ id, cable = false }) => {
    const params = { attributes: ['id', 'result', 'status', 'updated_at'] };
    const response = await axios.get(`/pen_study_analyses/${id}`, { params });
      
    return { data: response.data, cable };
  } 
});
export const clearLocalPenStudyAnalyses = createAction('penStudyAnalyses/clearLocalPenStudyAnalyses');
export const clearLocalActivePenStudyAnalysis = createAction('penStudyAnalyses/clearLocalActivePenStudyAnalysis');